import { render, staticRenderFns } from "./ShainExpDetails.vue?vue&type=template&id=2f599c4a&scoped=true"
import script from "./ShainExpDetails.vue?vue&type=script&lang=js"
export * from "./ShainExpDetails.vue?vue&type=script&lang=js"
import style0 from "./ShainExpDetails.vue?vue&type=style&index=0&id=2f599c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f599c4a",
  null
  
)

export default component.exports